import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=698f4c12&scoped=true"
import script from "./AddProduct.vue?vue&type=script&lang=js"
export * from "./AddProduct.vue?vue&type=script&lang=js"
import style0 from "./AddProduct.vue?vue&type=style&index=0&id=698f4c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698f4c12",
  null
  
)

export default component.exports